import { Route, Routes } from "react-router-dom";
import { PericiaCreatePage } from "../../pages/pericia/create-pericia.page";
import { PericiaUpdatePage } from "../../pages/pericia/update-pericia.page";
import { ListPericiasPage } from "../../pages/pericia/list-pericias.page";
import ListPericiasByDateRangePage from "../../pages/pericia/list-pericias-by-date-range.page";
import { GetPericiasMetricsPage } from "../../pages/pericia/get-pericias-metrics.page";
import { GetPericiasMetricsByCostumerPage } from "../../pages/pericia/get-pericias-metrics-by-costumer.page";
import { GetProfitMetricsPage } from "../../pages/metrics/get-profit-metrics.page";
import { GetPericiasMetricsByCostumersPage } from "../../pages/pericia/get-pericias-metrics-by-costumers.page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const PericiasRoutes = () => {
  return (
    <Routes>
      <Route path="/add" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.PERICIAS}><PericiaCreatePage /></RoleProtectedRoute>} />
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.PERICIAS}><ListPericiasPage /></RoleProtectedRoute>} />
      <Route path="/metrics" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.METRICS}><GetPericiasMetricsPage /></RoleProtectedRoute>} />
      <Route path="/metrics/profit" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.METRICS}><GetProfitMetricsPage /></RoleProtectedRoute>} />
      <Route path="/metrics/by-costumer" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.METRICS}><GetPericiasMetricsByCostumerPage /></RoleProtectedRoute>} />
      <Route path="/metrics/by-costumers" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.METRICS}><GetPericiasMetricsByCostumersPage /></RoleProtectedRoute>} />
      <Route path="/list/by-date" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.REPORTS}><ListPericiasByDateRangePage /></RoleProtectedRoute>} />
      <Route path=":periciaID" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.PERICIAS}><PericiaUpdatePage /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default PericiasRoutes;
